export default "__VITE_ASSET__B_fZLDX5__"